import {getRouteApi} from "@tanstack/react-router";

export const representativesRouteApi = getRouteApi("/_app/sales/representatives/");
